import {
  MENTOR_LIST_SUCCESS,
  MENTOR_INFO_SUCCESS,
  MENTOR_CREATE_SUCCESS,
  MENTOR_UPDATE_SUCCESS,
  MENTOR_DELETE_SUCCESS,
  MENTOR_STATUS_UPDATE_SUCCESS,
  CLEAR_MENTOR_INFO,
} from "../actionTypes/mentors";

const INIT_STATE = {
  mentorList: [],
  mentorInfo: {},
  queryInfo: {
    page: 1,
    size: 10,
  },
  totalRecords: 0,
  pages: 0,
  isSuccess: false,
};

function MentorReducer(state = INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case CLEAR_MENTOR_INFO: {
      return {
        ...state,
        mentorInfo: {},
      };
    }
    case MENTOR_LIST_SUCCESS: {
      return {
        ...state,
        mentorList: payload.data || [],
        queryInfo: {
          ...state.queryInfo,
          ...payload.queryInfo,
        },
        totalRecords: payload.count || 0,
        pages: payload.pages || 0,
        isSuccess: false,
      };
    }
    case MENTOR_INFO_SUCCESS: {
      return {
        ...state,
        mentorInfo: payload,
      };
    }
    case MENTOR_CREATE_SUCCESS: {
      return {
        ...state,
        mentorList: [payload, ...state.mentorList],
        mentorInfo: payload,
        totalRecords: state.totalRecords + 1,
        isSuccess: true,
      };
    }
    case MENTOR_UPDATE_SUCCESS:
    case MENTOR_STATUS_UPDATE_SUCCESS: {
      return {
        ...state,
        mentorList: state.mentorList.map((item) =>
          item._id === payload._id ? { ...item, ...payload } : item
        ),
        mentorInfo: state.mentorInfo?._id === payload._id ? { ...state.mentorInfo, ...payload } : state.mentorInfo,
        isSuccess: true,
      };
    }
    case MENTOR_DELETE_SUCCESS: {
      return {
        ...state,
        mentorList: state.mentorList.filter((item) => item._id !== payload.id),
        totalRecords: Math.max(0, state.totalRecords - 1),
      };
    }
    default:
      return state;
  }
}

export default MentorReducer;
